export default {
  items: [
    "Mandarin",
    "Vietnamese",
    "Italian",
    "Cantonese",
    "Arabic",
    "Spanish",
    "Karen",
    "Indonesian",
    "Burmese",
    "Persian (excluding Dari)",
    "Macedonian",
    "Portuguese",
    "Thai",
    "Croatian",
    "Dari",
    "Polish",
    "Malay",
    "Greek",
    "Tagalog",
    "Khmer",
    "French",
    "Dinka",
    "Somali",
    "Tamil",
    "Min Nan",
    "Bosnian",
    "Kriol",
    "Hazaraghi",
    "Hindi",
    "Auslan",
    "Japanese",
    "Korean",
    "Punjabi"
  ]
}



// WEBPACK FOOTER //
// ../data/qld/language.js